import '@/styles/object/project/_questionnaire.scss';

$(document).on('keypress', '.js-prevent-enter-submit', function (e) {
  if ((e as JQuery.KeyPressEvent).key === 'Enter') {
    e.preventDefault();
  }
});

$(document).on('click', '#answer_submit', function () {
  if (!$('.multi-select-group').length) {
    return;
  }
  $('.multi-select-group').each(function (_index, element) {
    if ($(element).data('required')) {
      validateMultiSelect($(element).data('group'));
    }
  });
});

function validateMultiSelect(groupId: string) {
  const checkedsum = $(`.multi-select-group-${groupId}:checked`).length;
  const element = $(`.multi-select-group-${groupId}`)[0] as HTMLInputElement;
  if (checkedsum === 0) {
    element.setCustomValidity('いずれかを選択してください');
  } else {
    element.setCustomValidity('');
  }
}
